import React from 'react';
import Header from './Header';

interface OnboardingCardProps {
  leftPanel: React.ReactNode;
  rightPanel?: React.ReactNode;
  pageInfo?: {
    currentPage: number;
    totalPages: number;
  };
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({ 
  leftPanel, 
  rightPanel,
  pageInfo
}) => {
  return (
    <div className="flex flex-col h-screen w-screen">
      <div className="flex w-full h-full">
        {/* Left Panel - 50% width */}
        <div className="w-1/2 bg-[#FFFFFF] flex flex-col h-full">
          <div className="flex flex-col h-full px-[152px] pt-[32px] pb-[28px]">
            {/* Header */}
            <div className="flex flex-col pl-[16px]">
              <Header />
            </div>
            <div className="flex flex-col h-full mt-[144px]">
              {/* Page Info - Only shown if provided */}
              {pageInfo && (
                <div className="text-start text-[12px] text-[#5C5E63] font-light pl-[16px]">
                  {pageInfo.currentPage}/{pageInfo.totalPages}
                </div>
              )}
              {leftPanel}
            </div>
          </div>
        </div>

        {/* Right Panel - 50% width */}
        <div className="w-1/2 bg-[#FAFAFA] flex items-start justify-start h-full relative overflow-hidden">
          {rightPanel || (
            <div className="flex items-center justify-center">
              <div className="text-4xl text-gray-400">×</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingCard; 